import { Form } from 'react-bootstrap'
import './ListRadioOptions.css'

export default function ListRadioOptions({ label, items, value, onSelect, className, divStyle, id, testId }) {
    const Item = ({ item, index }) => {

        return (
            <>
                <Form.Check
                    className={className}
                    label={item.text}
                    type={'checkbox'}
                    value={item.value}
                    onChange={() => {
                        onSelect(item.value)
                    }}
                    checked={item.value === value}
                    id={`checkbox-${item.value}-${id}`}
                    htmlFor={`checkbox-${item.value}`}
                    data-testid={testId ? `${testId}-${index}` : undefined}
                />
            </>
        )
    }

    return (
        <div className={`list-radio-options ${divStyle}`} >
            {label && <Form.Label>{label}</Form.Label>}
            {items.map((item, index) => <Item key={item.value} item={item} index={index} />)}
        </div>
    )
}